import React, { useContext } from "react";
import { Stack, IconButton, Tooltip } from "@mui/material";
import ChatBubbleTwoToneIcon from '@mui/icons-material/ChatBubbleTwoTone';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import PropTypes from "prop-types";
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import { useTranslation } from "react-i18next";
import { UserContext } from "../../../context/UserContext";

const options = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
};

const KanbanCardComment = (props) => {
    const { user } = useContext(UserContext);
    const { t } = useTranslation();
    const formatDateTime = (dateTimeString) => {
        const date = new Date(Date.parse(dateTimeString));
        return (date.toLocaleDateString(options) + " " + date.toLocaleTimeString());
    }

    return (
        <>
            <Stack spacing={3}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent:"space-between" }}>
                        <div>
                            <ChatBubbleTwoToneIcon className="color color-medium-blue" />
                        </div>
                        {(user.email == props.comment.email) && (
                        <>
                            <div>
                                <Tooltip title={t("kanban.comments.editComment")}>
                                    <IconButton size="small"
                                        onClick={(e) => {
                                        e.stopPropagation();
                                            props.editComment(props.cardId, props.columnId, props.comment.id, props.comment.content)

                                        }}
                                    >
                                        <EditTwoToneIcon className="color color-medium-blue" />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title={t("kanban.comments.deleteComment")}>
                                    <IconButton size="small"
                                        onClick={(e) => {
                                        e.stopPropagation();
                                            props.deleteComment(props.comment.id)
                                        }}
                                    >
                                        <DeleteTwoToneIcon className="color color-medium-red" />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        </>
                        )}
                    </div>
                    <Stack>
                        <div style={{ fontSize: '14px', fontWeight: '800' }}>
                            {props.comment.email}
                        </div>
                        <div style={{ fontSize: '12px', fontWeight: '400' }}>
                            {formatDateTime(props.comment.createdAt)}
                        </div>
                    </Stack>
                </div>
                <div style={{ fontSize: '12px', fontWeight: '400', marginTop: '10px', marginBottom: '25px', fontStyle: 'italic' }}>
                    {props.comment.content}
                </div>
            </Stack>
        </>
    );
}

KanbanCardComment.propTypes = {
    cardId: PropTypes.string, 
    columnId: PropTypes.number,
    comment: PropTypes.object,
    editComment: PropTypes.func,
    deleteComment: PropTypes.func
};

export default KanbanCardComment;